import { StaffAccessLevels } from "@/enums/StaffAccessLevels";

export interface Reports {
  name: string;
  route: string;
  icon: string;
  accessLevels?: StaffAccessLevels[];
}

export const reportsItems: Reports[] = [
/*  {
    name: "Reports.VisitsReport",
    route: "reportVisit",
    icon: "account-group"
  },*/
  {
    name: "Reports.LifestyleEventsReport",
    route: "lifestyleEventsReport",
    icon: "basketball-hoop-outline",
    accessLevels: [StaffAccessLevels.OrgAdmin, StaffAccessLevels.FacilityAdmin, StaffAccessLevels.RegionalAdmin, StaffAccessLevels.FacilityUser]
  },
  {
    name: "Reports.LifestyleProgramsReport",
    route: "report-lifestyle-programs-report",
    icon: "basketball",
    accessLevels: [StaffAccessLevels.OrgAdmin, StaffAccessLevels.FacilityAdmin, StaffAccessLevels.RegionalAdmin]
  },
  /*
  Temporary disabled from 01-08-2023
  {
    name: "Reports.SocialEventsReport",
    route: "reportEvents",
    icon: "widgets"
  },*/
  {
    name: "Reports.PremiumServiceReports",
    route: "premium-service-reports",
    icon: "star-circle",
    accessLevels: [StaffAccessLevels.OrgAdmin, StaffAccessLevels.FacilityAdmin, StaffAccessLevels.RegionalAdmin, StaffAccessLevels.FacilityUser]
  },
  {
    name: "Reports.ServiceRequestReport",
    route: "reportRequests",
    icon: "face-agent",
    accessLevels: [StaffAccessLevels.OrgAdmin, StaffAccessLevels.FacilityAdmin, StaffAccessLevels.RegionalAdmin, StaffAccessLevels.FacilityUser]
  },
  {
    name: "Reports.Resident360Report",
    route: "reports360",
    icon: "face-man",
    accessLevels: [StaffAccessLevels.OrgAdmin, StaffAccessLevels.FacilityAdmin, StaffAccessLevels.RegionalAdmin, StaffAccessLevels.FacilityUser]
  },
  /*{
    name: "Reports.FamilyMembersReport",
    route: "family-members-report",
    icon: "account-group"
  },*/
  {
    name: "Reports.FamilyReport",
    route: "family-report",
    icon: "account-group",
    accessLevels: [StaffAccessLevels.OrgAdmin, StaffAccessLevels.FacilityAdmin, StaffAccessLevels.RegionalAdmin, StaffAccessLevels.FacilityUser]
  },
  {
    name: "Reports.OrganisationalHealthDashboard",
    route: "report-organisational-health-dashboard",
    icon: "home-group",
    accessLevels: [StaffAccessLevels.OrgAdmin]
  },
  {
    name: "Reports.ActivitiesReport",
    route: "adHocActivitiesReport",
    icon: "calendar-heart-outline",
    accessLevels: [StaffAccessLevels.OrgAdmin, StaffAccessLevels.FacilityAdmin]
  },
  {
    name: "Reports.CommunityHealthDashboard",
    route: "report-community-health-dashboard",
    icon: "home",
    accessLevels: [StaffAccessLevels.OrgAdmin, StaffAccessLevels.FacilityAdmin, StaffAccessLevels.RegionalAdmin]
  },
  {
    name: "Reports.Maintenance",
    route: "report-maintenance",
    icon: "wrench",
    accessLevels: [StaffAccessLevels.OrgAdmin, StaffAccessLevels.FacilityAdmin, StaffAccessLevels.RegionalAdmin, StaffAccessLevels.MaintenanceAdmin]
  }
];
